import { Action, createReducer, on } from '@ngrx/store';

import * as fromActions from './actions';
import * as fromState from './state';

export const reducer = createReducer(
  fromState.initialState,
  on(fromActions.downloadRequest, (state) => ({
    ...state,
    isLoading: true,
    progress: null,
    pending: null,
    total: null,
    error: null,
  })),

  on(fromActions.downloadProgress, (state, { progress, pending, total }) => ({
    ...state,
    isLoading: true,
    progress,
    pending,
    total,
    error: null,
  })),

  on(fromActions.downloadSuccess, (state) => ({
    ...state,
    isLoading: false,
    progress: 100,
    pending: 0,
    error: null,
  })),
  on(fromActions.downloadFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    progress: null,
    pending: null,
    total: null,
    error,
  })),

  on(fromActions.checkRoomDeletedRequest, (state) => ({
    ...state,
    isLoading: true,
    progress: null,
    pending: null,
    total: null,
    error: null,
  })),
  on(fromActions.checkRoomDeletedSuccess, (state) => ({
    ...state,
    isLoading: false,
    error: null,
  })),
  on(fromActions.checkRoomDeletedFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error,
  })),
  on(fromActions.resetState, () => fromState.initialState),
);

export function downloadMappingChannelReducer(
  state: fromState.State | undefined,
  action: Action,
) {
  return reducer(state, action);
}
